import * as Buffer from 'buffer';
let b = Buffer.Buffer;
eval("window.Buffer = b");
